<template>
  <Header />
  <div class="container d-flex align-items-center justify-content-center" style="height: 90vh;">
    <div class="col-md-6 shadow p-4 bg-white rounded registro-contenedor">
      <h2 class="mb-4 text-center titulo-formulario">Registro de Usuario</h2>
      <RegisterForm />
    </div>
  </div>
</template>

<script setup>
import RegisterForm from '../components/RegisterForm.vue';
import Header from '../components/Header.vue';
</script>

<style scoped>

.registro-contenedor {
  font-family: Arial, Helvetica, sans-serif;
  border-left: 6px solid #4B0082;
}

.titulo-formulario {
  font-family: Arial, Helvetica, sans-serif;
  color: #4B0082;
  font-size: 2rem;
}
</style>